import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowThickUp2 = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.894,23.25A2.25,2.25,0,0,0,14.144,21V8.432L17.2,11.485A2.25,2.25,0,1,0,20.38,8.3L13.485,1.409a2.25,2.25,0,0,0-3.182,0L3.409,8.3a2.25,2.25,0,0,0,3.182,3.182L9.644,8.432V21A2.25,2.25,0,0,0,11.894,23.25Z",
		fill: "var(--icon-color, currentColor)"
	})
});
export default SvgArrowThickUp2;
